import React from "react";

/**
 * @author
 * @function BranchInboxView
 **/

const BranchInboxView = (props) => {
  return <div>BranchInboxView</div>;
};
export default BranchInboxView;
